/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface LeaderboardFieldDTO
 */
export interface LeaderboardFieldDTO {
    /**
     * 
     * @type {string}
     * @memberof LeaderboardFieldDTO
     */
    aggregation: LeaderboardFieldDTOAggregationEnum;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardFieldDTO
     */
    name: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof LeaderboardFieldDTO
     */
    type: AttributeTypeDTO;
}


/**
 * @export
 */
export const LeaderboardFieldDTOAggregationEnum = {
    Last: 'last',
    Min: 'min',
    Max: 'max',
    Average: 'average',
    Variance: 'variance',
    Auto: 'auto'
} as const;
export type LeaderboardFieldDTOAggregationEnum = typeof LeaderboardFieldDTOAggregationEnum[keyof typeof LeaderboardFieldDTOAggregationEnum];


/**
 * Check if a given object implements the LeaderboardFieldDTO interface.
 */
export function instanceOfLeaderboardFieldDTO(value: object): value is LeaderboardFieldDTO {
    if (!('aggregation' in value) || value['aggregation'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function LeaderboardFieldDTOFromJSON(json: any): LeaderboardFieldDTO {
    return LeaderboardFieldDTOFromJSONTyped(json, false);
}

export function LeaderboardFieldDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardFieldDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'aggregation': json['aggregation'],
        'name': json['name'],
        'type': AttributeTypeDTOFromJSON(json['type']),
    };
}

export function LeaderboardFieldDTOToJSON(value?: LeaderboardFieldDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aggregation': value['aggregation'],
        'name': value['name'],
        'type': AttributeTypeDTOToJSON(value['type']),
    };
}

